import { render, staticRenderFns } from "./AddPackageActivity.vue?vue&type=template&id=1163dec4"
import script from "./AddPackageActivity.vue?vue&type=script&lang=js"
export * from "./AddPackageActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports